import { useState } from "react";
import Moment from "react-moment";
import { useEffect } from "react";
import InviteData from "./InviteData";
import SendInvitation from "./SendInvitation";
import ToolBar from "../../Componant/ToolBar";
import { GrOrganization } from "react-icons/gr";
import UseToggle from "../../../Hooks/UseToggle";
import { inviteServices } from "../../../APIServices/UserData/inviteServices";
import { Button, Card, Col, Container, Form, Row, Table } from "react-bootstrap";
import Swal from "sweetalert2";

const InvitationManagement = ({ organizationList, getOrganizations, currentUserData }) => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [invitations, setInvitations] = useState([]);
  const [invitationData, setInvitationData] = useState("");
  const [invitationCount, setInvitationCount] = useState(0);
  const [invitationIds, setInvitationIds] = useState([]);

  const toggleSingle = (id) => {
    setInvitationIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const toggleAll = () => {
    if (invitationIds.length === invitationCount) {
      setInvitationIds([]);
    } else {
      setInvitationIds(invitations.map((c) => c._id));
    }
  };

  const isAllChecked =
    invitationCount > 0 && invitationIds.length === invitationCount;
  const isChecked = (id) => invitationIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(invitationCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, invitationCount);

  const getInvitationList = async () => {
    setLoader(true)
    let data = await inviteServices.getInvitation("all", search, pageNumber, itemsPerPage)
    setInvitations(data?.data || [])
    setInvitationCount(data?.count || 0)
    setLoader(false)
  }

  const getApprovalInvitation = async () => {
    setLoader(true)
    let data = await inviteServices.getApprovalInvitation("all", search, pageNumber, itemsPerPage)
    setInvitations(data?.data || [])
    setInvitationCount(data?.count || 0)
    setLoader(false)
  }

  const acceptRejectInvitation = async (adminId, userId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${status} this Invitation?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status}} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.adminId = adminId
        userData.userId = userId
        userData.status = status
        let data = await inviteServices.acceptRejectInvitation(userData)
        if (data?.statusCode === 200) {
          getApprovalInvitation()
          getOrganizations()
        }
      }
    });
  };

  useEffect(() => {
    if (currentUserData?.roleType === "organization") {
      getInvitationList()
    } else {
      getApprovalInvitation()
    }
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <div className="w-100" style={{ height: "calc(100vh - 57px)" }}>
        <ToolBar
          sendNow
          toggles={toggles}
          search={search}
          setSearch={setSearch}
          checkedIds={invitationIds}
          setCheckedIds={setInvitationIds}
          showPreview={showPreview}
          setShowPreview={setShowPreview}
          setSelected={setInvitationData}
          start={start}
          end={end}
          totalItems={invitationCount}
          page={pageNumber}
          setPage={setPageNumber}
          setPageSize={setItemsPerPage}
          pageSize={itemsPerPage}
          totalPages={totalPages}
          addField
          editField
        />

        <div className={`contacts-layout ${showPreview ? "with-preview" : ""}`}>
          <div className={`table-section overflow-auto bg-white ${showPreview ? "border-end" : ""}`} style={{ height: "calc(100vh - 108px)" }}>
            {currentUserData?.roleType === "organization" ?
              <Table hover className="contacts-table mb-0" style={{ verticalAlign: "middle" }}>
                <thead>
                  <tr>
                    <th>
                      <div className="d-flex align-items-center gap-2">
                        <div className="px-2">
                          <Form.Check
                            type="checkbox"
                            checked={isAllChecked}
                            onChange={toggleAll}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                        <div>Email</div>
                      </div>
                    </th>
                    {!invitationData && (
                      <>
                        <th>Invited By</th>
                        <th>Invitation Date | Time</th>
                        <th>Accept / Reject Date | Time</th>
                        <th>Status</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {invitations.map((item) => (
                    <tr key={item._id} className={`contact-row ${invitationData?._id === item._id ? "active" : ""}`} onClick={() => { setInvitationData(item); setShowPreview(true); }}>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <div className="px-2">
                            <Form.Check
                              type="checkbox"
                              checked={isChecked(item._id)}
                              onChange={() => toggleSingle(item._id)}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                          <div>
                            <div className="fw-medium">{item.email}</div>
                            <small className="text-muted">{item.designation}</small>
                          </div>
                        </div>
                      </td>

                      {!invitationData && (
                        <>
                          <td>{item.invitedByName}</td>
                          <td>
                            <Moment format="DD MMM YYYY | HH:mm" withTitle>
                              {item?.invitationDate}
                            </Moment>
                          </td>
                          <td>
                            {item.acceptRejectDate ?
                              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                {item?.invitationDate}
                              </Moment>
                              : "_"
                            }
                          </td>
                          <td><span className={`text-capitalize badge ${item.status === "accepted" ? "bg-success" : item.status === "rejected" ? "bg-danger" : "bg-warning text-dark"}`}>{item.status}</span></td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
              :
              <div className="p-0">
                <div className="w-100 m-auto p-3">
                  <Card className="border rounded-1 mb-3">
                    <Card.Body className="overflow-auto" style={{ maxHeight: "calc(100vh - 150px)" }}>
                      <Container fluid>
                        {invitations?.map((item, index) => (
                          <Row key={index} className="my-3 align-items-center">
                            <Form.Group as={Col} md={3}>
                              <div className="d-flex gap-2 align-items-start">
                                <span style={{ fontSize: 24 }} className="text-muted">
                                  <GrOrganization />
                                </span>
                                <div style={{ lineHeight: 1.3 }}>
                                  <h6 className="mb-1 fw-bold" style={{ fontSize: 14 }}>
                                    {item?.name}
                                  </h6>
                                  <Form.Label className="m-0 d-block" style={{ fontSize: 11 }}>
                                    <span>{item?.email}</span>
                                  </Form.Label>
                                </div>
                              </div>
                            </Form.Group>
                            <Form.Group as={Col} md={2}>
                              <div style={{ lineHeight: 1.3 }}>
                                <Form.Label className="m-0 d-block fw-bold" style={{ fontSize: 11 }}>
                                  Invitation DT
                                </Form.Label>
                                <Form.Label className="m-0 d-block" style={{ fontSize: 11 }}>
                                  <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                    {item?.invitationDate}
                                  </Moment>
                                </Form.Label>
                              </div>
                            </Form.Group>
                            <Form.Group as={Col} md={2}>
                              <div style={{ lineHeight: 1.3 }}>
                                <Form.Label className="m-0 d-block fw-bold" style={{ fontSize: 11 }}>
                                  Accept / Reject DT
                                </Form.Label>
                                <Form.Label className="m-0 d-block" style={{ fontSize: 11 }}>
                                  {item?.acceptRejectDate ?
                                    <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                      {item?.acceptRejectDate}
                                    </Moment>
                                    : "NA"}
                                </Form.Label>
                              </div>
                            </Form.Group>
                            <Form.Group as={Col} md={2}>
                              <div style={{ lineHeight: 1.3 }}>
                                <Form.Label className="m-0 d-block fw-bold" style={{ fontSize: 11 }}>
                                  Invitation Status
                                </Form.Label>
                                <Form.Label className={`m-0 d-block text-capitalize ${item?.status === "accepted" ? "text-success" : item?.status === "rejected" ? "text-danger" : "text-warning"}`} style={{ fontSize: 11 }}>
                                  {item?.status}
                                </Form.Label>
                              </div>
                            </Form.Group>
                            <Form.Group as={Col} md={2}>
                              <div style={{ lineHeight: 1.3 }}>
                                <Form.Label className="m-0 d-block fw-bold" style={{ fontSize: 11 }}>
                                  Access Status
                                </Form.Label>
                                <Form.Label className={`m-0 d-block text-capitalize ${item?.accessStatus === "granted" ? "text-success" : item?.accessStatus === "pending" ? "text-warning" : "text-danger"}`} style={{ fontSize: 11 }}>
                                  {item?.accessStatus}
                                </Form.Label>
                              </div>
                            </Form.Group>
                            <Form.Group as={Col} md={1}>
                              <div className="hstack gap-2 justify-content-end">
                                <Button
                                  onClick={() => acceptRejectInvitation(item?.adminId, item?.userId, "accepted")}
                                  variant={item?.status === "pending" ? "outline-success" : "outline-secondary"}
                                  className="rounded-1 text-nowrap py-1 px-2"
                                  style={{ fontSize: 11 }}
                                  disabled={item?.status != "pending"}
                                  title="Accept Invitation"
                                >
                                  Accept
                                </Button>
                                <Button
                                  onClick={() => acceptRejectInvitation(item?.adminId, item?.userId, "rejected")}
                                  variant={item?.status === "pending" ? "outline-danger" : "outline-secondary"}
                                  className="rounded-1 text-nowrap py-1 px-2"
                                  style={{ fontSize: 11 }}
                                  disabled={item?.status != "pending"}
                                  title="Reject Invitation"
                                >
                                  Reject
                                </Button>
                              </div>
                            </Form.Group>
                          </Row>
                        ))}
                      </Container>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            }
          </div>
          <div className={`preview-section ${showPreview ? "open" : ""}`}>
            {invitationData && (
              <div className="overflow-auto" style={{ height: "calc(100vh - 108px)" }}>
                <div className="preview-scroll p-0">
                  <div className="preview-block">
                    <InviteData invitationId={invitationData?._id} />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <SendInvitation
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Send Invitation`}
        getInvitationList={getInvitationList}
        organizationList={organizationList}
      />
    </>
  );
};

export default InvitationManagement;
